const apiConfig = require("./api.json");
const tokenConfig = require("./token.json");

export const apiUrl = apiConfig.apiUrl;
export const token = tokenConfig;
